import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Details } from "../../services/transaction.services";
import TransactionReceipt from "../../../../utils/transactionPdf";
import { showFormattedDate, currencyCovMap } from "../../../../utils/commonfunction";

export default function BusinessTransactionDetails() {
  const { transactionId } = useParams();
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [transactionData , setTransactionData] = useState({})

  

  useEffect(() => {
    if (transactionId) {
      Details(transactionId)
        .then((res) => {
          setTransaction(res.data);
          // fallback currency
          const currency = res.data?.currency || "$";

          let data = {
            userName: res.data?.userName || "NA",
            transactionID: res.data?.transactionID || "NA",
            billingDate: showFormattedDate(res.data?.createdAt) || "NA",
            customerName: res.data?.user?.[0]?.fullName || "NA",
            type: res.data?.paymentMethod || "NA",
            status: res.data?.status || "NA",

            // Amounts with default $ if missing
            discountAmount: res.data?.discountAmount ? `${currency} ${res.data.discountAmount}` : `${currency} 0`,

            totalAmount: res.data?.totalAmount ? `${currency} ${res.data.totalAmount}` : `${currency} 0`,

            netPay: res.data?.netPay ? `${currency} ${res.data.netPay}` : `${currency} 0`,

            offerName: res.data?.offer?.[0]?.name || "NA",
            currency, // keep final resolved currency
          };

          setTransactionData(data);
        })
        .catch((err) => {
          console.error("Error fetching transaction:", err);
        })
        .finally(() => setLoading(false));
    }
  }, [transactionId]);

  if (loading) return <div>Loading...</div>;
  if (!transaction) return <div>Transaction not found.</div>;

  return (
    <div className="main-content">
      <div className="Transactions-part">
        <div className="card-box">
          <div className="row">
           
            <div className="col-md-3">
              <p className="text-color">ID</p>
              <p className="subtitle-1 ps-3">#{transaction.transactionID}</p>
              <p className="text-color">Offer Used</p>
              <p className="subtitle-1 ps-3">{transaction.offer_id ? transaction.offer[0].name : transaction.offerPercentage + "%"}</p>
              <p className="text-color">Type</p>
              <p className="subtitle-1 ps-3">{transaction.paymentMethod || "N/A"}</p>
              <p className="text-color">Reference ID</p>
              <p className="subtitle-1 ps-3">{transaction.transactionID || "N/A"}</p>
              {/* <button className="btn btn-oring mb-2 ms-3 mt-4">Download Receipt  </button> */}
              <TransactionReceipt transactionData = {transactionData}/>
            </div>
            <div className="col-md-3">
              <p className="text-color">Customer Email</p>
              <p className="subtitle-1 ps-3">{transaction?.user?.[0]?.email || transaction?.userEmail || (transaction?.userName?.includes("@") ? transaction?.userName : null) || "N/A"}</p>
              <p className="text-color">Customer Name</p>
              <p className="subtitle-1 ps-3">{transaction?.user?.[0]?.fullName || transaction?.userName || "N/A"}</p>
              <p className="text-color">Amount</p>
              <p className="subtitle-1 ps-3">
                {currencyCovMap[transaction.currency?.toUpperCase()] || "£"} {transaction?.netPay}
              </p>
              <p className="text-color">Status</p>
              <p className="subtitle-1 ps-3 pt-0">{transaction?.status}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
